import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { Section } from "@/components/Section";
import { KeyIdea, Tip } from "@/components/Callouts";

export default function EdSheeran6() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "6");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section title="Chord Chart">
        <NoteImage
          src="/notes/ed-sheeran/finals/06-camera.png"
          caption="Jason's chord chart for Camera"
        />
      </Section>

      <Section title="Intro — No-Third Chord">
        <RomanNumeralAnalysis
          label="Intro · D major — Dadd9(no3)"
          chords={[
            {
              chord: "Dadd9(no3)",
              rn: "Iadd9",
              function: "Tonic",
              pitches: ["D3", "A3", "E4"],
            },
          ]}
        />
        <KeyIdea title="Special moment">
          Omitting the 3rd removes the chord's major/minor identity entirely. Without an F♯ or F,
          the chord floats — neither bright nor dark. That ambiguity is the shimmer of Camera's intro.
        </KeyIdea>
      </Section>

      <Section title="Verse">
        <RomanNumeralAnalysis
          label="Verse · D major"
          chords={[
            { chord: "Bm", rn: "vi", function: "Submediant", pitches: ["B2", "D3", "F#3", "B3"] },
            { chord: "A", rn: "V", function: "Dominant", pitches: ["A2", "C#3", "E3", "A3"] },
            { bar: true },
            { chord: "G", rn: "IV", function: "Pre-dominant", pitches: ["G2", "B2", "D3", "G3"] },
          ]}
        />
        <Tip>
          vi–V–IV: the roots step down B → A → G, and Jason holds the G for a second bar before
          the loop starts again. Starting on Bm, the minor vi, darkens the verse without leaving
          D major.
        </Tip>
      </Section>

      <Section title="Watch">
        <YouTubeEmbed videoId="O8WXFI_MSAI" />
      </Section>
    </LessonShell>
  );
}
